import React, { useEffect, useRef, useState } from "react";
import { BASE_URL } from "../../../constants";
import { Card, CardBody, Col, Row } from "reactstrap";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick
import { useNavigate } from "react-router-dom";
import AddInspectionPopup from "../inspection/AddInspectionPopup";
import axios from "axios";

let apiTimeoutId = null;

function renderEventContent(eventInfo) {
	// console.log('renderEventContent', eventInfo, eventInfo.event.title, eventInfo.event.start, eventInfo.event.extendedProps.extendedProp.type)

	// eventInfo.event.extendedProps.extendedProp.type

	const inspectionTypes = {
		MOVE_IN: 'Move In',
		MOVE_OUT: 'Move Out',
		MANAGER_INSPECTION: 'Manager',
		INTERMITTENT_INSPECTION: 'Intermittent',
	};

	let tenantNames = [];

	if (eventInfo.event.extendedProps.extendedProp.data.tenants && eventInfo.event.extendedProps.extendedProp.data.tenants.length) {

		eventInfo.event.extendedProps.extendedProp.data.tenants.map(tenant => {
			tenantNames.push(tenant.first_name + ' ' + tenant.last_name);
		})
	}

	const inspectionType = eventInfo.event.extendedProps.extendedProp.data.activity

	return (
		<div className="p-2">
			<div>
				<strong>{eventInfo.event.title}</strong>
			</div>
			<div>
				Inspection Type: {inspectionTypes[inspectionType] || inspectionType}
			</div>
			{(!['INTERMITTENT_INSPECTION', 'MANAGER_INSPECTION'].includes(inspectionType)) ? (
			<div className="mt-2">
				Renters: {tenantNames.join(', ')}
			</div>
			) : null}
		</div>
	)
}

function Calendar() {
	const calendarRef = useRef(null)
	const navigate = useNavigate();

	const [events, setEvents] = useState([
		// { title: 'event 1', start: new Date('2025-03-06'), end: new Date('2025-03-07'), extendedProp: {type: 'inspection'} },
		// { title: 'event 2', date: '2025-03-12', extendedProp: {type: 'testing'} },
	])
	const monthStart = new Date();
	monthStart.setDate(1);
	const monthEnd = new Date();
	monthEnd.setMonth(monthEnd.getMonth() + 1);
	monthEnd.setDate(0);

	const [monthStartDate, setMonthStartDate] = useState(monthStart)
	const [monthEndDate, setMonthEndDate] = useState(monthEnd)

	const [createInspectionForDate, setCreateInspectionForDate] = useState(false);

	useEffect(() => {
		if (apiTimeoutId) clearTimeout(apiTimeoutId);

		apiTimeoutId = setTimeout(() => {
			getCalendarData();
		}, 500);
	}, [monthStartDate, monthEndDate, createInspectionForDate]);

	const getCalendarData = async () => {
		const token = localStorage.getItem('token');
		if (!token) {
			return
		}

		const params = new URLSearchParams({
			start_date: `${monthStartDate.getFullYear()}-${(monthStartDate.getMonth() + 1).toString().padStart(2, '0')}-${monthStartDate.getDate().toString().padStart(2, '0')}`,
			end_date: `${monthEndDate.getFullYear()}-${(monthEndDate.getMonth() + 1).toString().padStart(2, '0')}-${monthEndDate.getDate().toString().padStart(2, '0')}`,
		});
		// console.log(params.toString(), 'params')
		fetch(`${BASE_URL}/calendar/list?${params}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
			.then(response => response.json())
			.then(data => {
				if (data.status) {
					if (data.result && Object.keys(data.result).length > 0) {
						let inspEvents = [];
						for (const key in data.result) {
							if (data.result.hasOwnProperty(key)) {
								const inspections = data.result[key];

								if (inspections && inspections.length) {
									inspections.forEach(element => {

										let color = 'rgba(46,106,84,0.9)'; // manager or intermediate
										let textColor = '#ffffff';
										if (element.data.is_completed == 1) {
											color = 'rgba(15,152,0,0.9)';
										}
										else if (element.data.activity == 'MOVE_OUT' || element.data.activity == 'MOVE_IN') {
											color = 'rgba(255,110,7,0.9)';
										}

										inspEvents.push({
											id: element.data.id,
											title: element.data.name,
											date: key,
											backgroundColor: color,
											borderColor: color,
											textColor: textColor,
											extendedProp: {
												...element,
											}
										});
									});
								}
							}
						}

						setEvents([...inspEvents]);
					}
				}
				else {
					console.log("Error: Unable to fetch calendar data.");
				}
			})
			.catch(error => console.log("Error fetching data:", error));
	}

	const handleDateClick = (arg) => {
		console.log('handleDateClick', arg, arg.dateStr)
		setCreateInspectionForDate(arg.dateStr)
	}
	function handleDateSelect(selectInfo) {
		console.log('handleDateSelect', selectInfo)
		// let title = window.prompt('Please enter a new title for your event')
		// let calendarApi = selectInfo.view.calendar

		// calendarApi.unselect() // clear date selection

		// if (title) {
		// 	calendarApi.addEvent({
		// 		id: Math.random(),
		// 		title,
		// 		start: selectInfo.startStr,
		// 		end: selectInfo.endStr,
		// 		allDay: selectInfo.allDay
		// 	})
		// }
	}

	const handleEventClick = async (clickInfo) => {
		console.log('handleEventClick', clickInfo, clickInfo.event.title, clickInfo.event.start, clickInfo.event.extendedProps.extendedProp.type)
		// if (window.confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
		//   clickInfo.event.remove()
		// }

		if (clickInfo.event.extendedProps && clickInfo.event.extendedProps.extendedProp && clickInfo.event.extendedProps.extendedProp.type === 'inspection') {
			// navigate to inspection view
			navigate(`/inspection/view/${clickInfo.event.id}`, {
				state: {
					inspections: clickInfo.event.extendedProps.extendedProp.data
				}
			});
		}
	}


	function handleEvents(events) {
		console.log('handleEvents', events)
	}

	// on month view change
	const handleDatesSet = async (dateInfo) => {
		console.log('handleDatesSet', dateInfo)
		const monthEnd = new Date(dateInfo.end);
		monthEnd.setDate(0);
		setMonthStartDate(dateInfo.start);
		setMonthEndDate(monthEnd);
	}

	const handleEventUpdate = (changeInfo) => {
		console.log('eventChange', changeInfo)
		// console.log('eventChange', changeInfo.event._def.extendedProps.extendedProp)

		if (changeInfo.event._def && 
			changeInfo.event._def.extendedProps && 
			changeInfo.event._def.extendedProps.extendedProp && 
			changeInfo.event._def.extendedProps.extendedProp.type === 'inspection') {

			const updateData = {
				inspection_date: changeInfo.event.startStr,
			}

			const token = localStorage.getItem('token');
			if (!token) {
				return
			}

			axios.put(`${BASE_URL}/inspection/update/${changeInfo.event.id}`, updateData, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			.then(response => {
				const data = response.data;
				if (data.status) {
					
				}
				else {
					changeInfo.revert();
					alert(data.message);
				}
			})
			.catch(error => {
				console.error("Error:", error);
				// setErrMsg(error.message);
			});
		}
	}

	return (
		<div className="content">
			<Row>
				<Col xs="6">
					<h4 className="mt-0">Calendar</h4>
				</Col>
			</Row>
			<Card>
				<CardBody>
					<FullCalendar
						ref={calendarRef}
						plugins={[dayGridPlugin, interactionPlugin]}
						initialView="dayGridMonth"
						events={events}
						editable={true}
						// selectable={true}
						// selectMirror={true}
						dayMaxEvents={true}
						// showNonCurrentDates={false}
						dateClick={handleDateClick}
						// select={handleDateSelect}
						eventContent={renderEventContent} // custom render function
						eventClick={handleEventClick}
						// eventsSet={handleEvents}
						datesSet={handleDatesSet}
						eventChange={handleEventUpdate}
					/>
				</CardBody>
			</Card>

			{(createInspectionForDate) ? (
				<AddInspectionPopup open={createInspectionForDate != false} setOpen={setCreateInspectionForDate} date={createInspectionForDate} />
			) : null}
		</div>
	)
}

// TODO:
// create new schedule inspection functionality on date click
// add drag and drop functionality to move inspection dates

export default Calendar